import {Component, OnInit, Inject} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {Http, Response, Headers} from '@angular/http';
import {HelperService} from '../helper.service';
import {MatSnackBar} from '@angular/material';
import {CookieService} from 'angular2-cookie/core';
import {UserIdleService} from 'angular-user-idle';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {VERSION} from '@angular/core';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [HelperService, CookieService]
})
export class LoginComponent implements OnInit {
  logouttimer;

  version = VERSION;

  constructor(private router: Router, private http: Http, private helper: HelperService, private snackbar: MatSnackBar, private cookie: CookieService, private userIdle: UserIdleService, public dialog: MatDialog) {
    //  if(cookie.get('auth')=="Y"){
    //       this.router.navigate(["/dashboard"]);
    //     }
  }

  ngOnInit() {
    console.log(this.version)
    localStorage.removeItem('navigateroute');
  }

  login(login: NgForm) {
    let body = new FormData();
    body.append('email', login.value.email);
    body.append('password', login.value.password);

    this.http.post(this.helper.base_url + 'http/login', body)
      .subscribe(
        (res) => {
          let user = JSON.parse(res['_body']);
          if (res['_body'] != '0' && res['_body'] != '2') {

            //  this.cookie.put('auth','Y');
            //this.cookie.put('user_id',user.id);
            //  this.cookie.put('user_image',user.image);

            localStorage.setItem('access_token', user.access_token);
            this.userIdle.startWatching();

            // Start watching when user idle is starting.
            this.userIdle.onTimerStart().subscribe(count =>
              console.log(count)
            );

            // Start watch when time is up.
            this.userIdle.onTimeout().subscribe(() => {
              //alert("time up");

              const dialogRef = this.dialog.open(ExpiredDialogBox, {
                height: '350px',
                width: '1000px',
                disableClose: true
              });

              dialogRef.afterClosed().subscribe(result => {

              });
              // this.isPopupVisible = true;
              //  this.childModal.show();

              //   this.cookie.removeAll();
              // localStorage.removeItem('access_token');
              // localStorage.removeItem('navigateroute');
              //   console.log('Time is up!');
              //   this.snackbar.open("Session Has Expired,Please Login Again", null, {
              //     duration:5000,
              //       extraClasses:'error-snackbar',
              //       verticalPosition:'top'
              //     });
              //   this.router.navigate(['login/'])
              //   .then(() => {
              //     window.location.reload();
              //   });
            });


            this.router.navigate(['/dashboard']);
          } else {
            if (res['_body'] == '2') {
              this.snackbar.open('Invalid Credentials', null, {
                duration: 5000,
                extraClasses: 'error-snackbar',
                verticalPosition: 'top'
              });
            } else {
              this.snackbar.open('Invalid Credentials', null, {
                duration: 5000,
                extraClasses: 'error-snackbar',
                verticalPosition: 'top'
              });
            }

          }
        }, //For Success Response
        err => {
          console.error(err);
        } //For Error Response);
      );
  }


}

@Component({
  selector: 'expired-dialog-box',
  templateUrl: 'expired-dialog-box.html',
})
export class ExpiredDialogBox {

  dialog = MAT_DIALOG_DATA;
  //user=this.cookie.get('user_id');
  user_token = localStorage.getItem('access_token');
  private headers: Headers = new Headers({
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + this.user_token
  });
  logouttimer;

  constructor(public dialogRef: MatDialogRef<LoginComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private http: Http, private cookie: CookieService, private snackbar: MatSnackBar, private router: Router, private userIdle: UserIdleService, private helper: HelperService) {


  }


  ngOnInit() {
    this.logouttimer = setTimeout(() => {
      //alert("after1 min");
      // this.userIdle.stopWatching();
      // this.cookie.removeAll();
      localStorage.removeItem('access_token');
      localStorage.removeItem('navigateroute');
      this.router.navigate(['/login'])
        .then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        });
    }, 300000);
  }

  restart() {
    //alert("restarting");
    clearTimeout(this.logouttimer);
    this.userIdle.resetTimer();
    this.dialogRef.close();
  }

  logout() {
    this.cookie.removeAll();
    localStorage.removeItem('access_token');
    localStorage.removeItem('navigateroute');
    let body = new FormData();

    //return;
    body.append('token', this.user_token);
    this.http.post(this.helper.base_url + 'http/logout', body, {headers: this.headers})
      .subscribe(data => {

        this.snackbar.open('Logged Out Successfully', null, {
          duration: 5000,
          extraClasses: 'success-snackbar',
          verticalPosition: 'top'
        });
      });
    this.router.navigate(['login/'])
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts